const owns = (row, key) => row != null && Object.prototype.hasOwnProperty.call(row, key);
const isTitle = (value) => value === null || typeof value === 'string';

// Read APIs historically omit empty title values, but preserve expectedTitle.
// Never coalesce null and empty: they are different compare-and-set baselines.
export const assignmentTitleBaseline = (row) => {
  if (owns(row, 'expectedTitle') && isTitle(row.expectedTitle)) return row.expectedTitle;
  if (owns(row, 'title') && isTitle(row.title)) return row.title;
  return undefined;
};

export const assignmentTitleRevision = (row) =>
  Number.isSafeInteger(row?.titleRevision) && row.titleRevision >= 0 ? row.titleRevision : undefined;

export const hasCanonicalAssignmentTitle = (row, id) =>
  row?.id === id && assignmentTitleBaseline(row) !== undefined;
